/* eslint-disable */
import ArrowBack from '@mui/icons-material/ArrowBack';
import {
  Button,
  IconButton,
  LinearProgress,
  Paper,
  Typography,
} from '@mui/material';
import React, { useContext, useEffect, useState } from 'react';
import { MdClose, MdPhoto, MdSource } from 'react-icons/md';
import { useParams } from 'react-router-dom';
import api, { authHeader } from '../../../../../services/API/apiConfig';
import { ImageSlider } from '../../../../components/ImageSlider/ImageSlider';
import { Alert } from '../../../../components/singleComponents/alerts/Alert';

import { TableFolder } from '../documents/TableFolder';

import { styled } from '@mui/system';
import GlobalContext from '../../../../../context/GlobalContext';
import {
  ContainerFolderNameStyled,
  DefaultPageStyled,
  DivNoDataStyled,
  LoadingProgressStyled,
  MainDivStyled,
  ModalStyled,
  PreviewStyled,
  RootStyled,
  SelectionDefaultStyled,
} from './ConstructionPhotos.styles';

const Backdrop = styled('div')`
  z-index: -1;
  position: fixed;
  right: 0;
  bottom: 0;
  top: 0;
  left: 0;
  background-color: rgba(255, 255, 255);
  -webkit-tap-highlight-color: transparent;
`;

const header = [' ', 'Pasta', 'Data da última modificação'];
const row = ['name', 'last_modified'];

export function ConstructionPhotos() {
  const { id } = useParams();
  const baseURL = process.env.REACT_APP_API;
  const protocol =
    process.env.REACT_APP_NODE_ENV === 'development' ? 'http' : 'https';
  const formData = false;

  const [folders, setFolders] = useState([]);
  const [folderShow, setFolderShow] = useState(false);
  const [picturesShow, setPicturesShow] = useState(false);
  const [folderPictures, setFolderPictures] = useState([]);
  const [selectedFolder, setSelectedFolder] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [index, setIndex] = useState(0);
  const [permissionPhotos, setPermissionPhotos] = useState(true);
  const [loading, setLoading] = useState(true);
  const {
    companyData: { subdomain },
  } = useContext(GlobalContext);

  const getFolders = async () => {
    await api
      .get(`/constructions/${id}/picture-folders`, {
        headers: authHeader(formData),
      })
      .then((res) => {
        const { data } = res.data;
        setFolderShow(true);
        setFolders(data);
        setLoading(false);
      })
      .catch(() => {
        setPermissionPhotos(false);
        setLoading(false);
      });
  };

  function handleCloseModal() {
    setOpenModal(!openModal);
  }

  useEffect(() => {
    getFolders();
  }, []);

  async function returnId(idRow) {
    setSelectedFolder(idRow);
    setPicturesShow(true);

    await api
      .get(`/folders/${idRow.id}/pictures`, {
        headers: authHeader(),
      })
      .then((res) => {
        const { data } = res.data;
        setFolderShow(false);
        setFolderPictures(data);
      });
  }

  return (
    <>
      <Paper>
        {permissionPhotos ? (
          <MainDivStyled>
            {loading ? (
              <LoadingProgressStyled>
                <Typography variant="h2">Carregando...</Typography>
                <LinearProgress style={{ width: '80%' }} />
              </LoadingProgressStyled>
            ) : (
              <>
                {folders.length ? (
                  <>
                    <RootStyled>
                      <ContainerFolderNameStyled>
                        {!folderShow && (
                          <>
                            <Button
                              variant="contained"
                              color="primary"
                              disableElevation
                              startIcon={<ArrowBack />}
                              onClick={() => setFolderShow(true)}
                            >
                              Retornar para lista de pastas
                            </Button>
                          </>
                        )}
                      </ContainerFolderNameStyled>
                      {folderShow ? (
                        <TableFolder
                          data={folders}
                          headings={header}
                          keys={row}
                          callbackClickRow={returnId}
                          editActions
                        />
                      ) : folderPictures.length ? (
                        <>
                          <SelectionDefaultStyled>
                            <div
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 7,
                              }}
                            >
                              <Typography variant="subtitle2">
                                TODAS AS FOTOS
                              </Typography>
                              <Typography
                                style={{ fontSize: 14, color: '#999' }}
                              >
                                ({folderPictures.length} fotos)
                              </Typography>
                            </div>
                          </SelectionDefaultStyled>
                          <PreviewStyled>
                            {folderPictures.lenght !== 0 &&
                              folderPictures.map((image, index) => (
                                <div key={image.id} className="image">
                                  <img
                                    src={`${protocol}://${subdomain}.${baseURL}${image.path.thumbnails.medium}`}
                                    alt={image.name}
                                    onClick={() => {
                                      setIndex(index);
                                      setOpenModal(true);
                                    }}
                                  />
                                </div>
                              ))}
                          </PreviewStyled>
                        </>
                      ) : (
                        <DivNoDataStyled>
                          <MdPhoto size={200} color="#B9B9B9" />
                          <Typography
                            variant="body1"
                            style={{ color: '#1c1c1ccc' }}
                          >
                            Nenhuma foto adicionada até o momento.
                          </Typography>
                        </DivNoDataStyled>
                      )}
                      {!folders.length && (
                        <DefaultPageStyled>
                          <MdSource />
                          <Typography>
                            Nenhuma pasta foi adicionada até o momento
                          </Typography>
                        </DefaultPageStyled>
                      )}
                    </RootStyled>
                  </>
                ) : (
                  <DivNoDataStyled>
                    <MdSource size={200} color="#B9B9B9" />
                    <Typography variant="body1" style={{ color: '#1c1c1ccc' }}>
                      Nenhuma pasta adicionada até o momento.
                    </Typography>
                  </DivNoDataStyled>
                )}
              </>
            )}
          </MainDivStyled>
        ) : (
          <Alert alertTitle="Fotos indisponível" />
        )}
      </Paper>
      <ModalStyled
        open={openModal}
        onClose={handleCloseModal}
        slot={{
          Backdrop: () => Backdrop,
        }}
      >
        <>
          <IconButton
            className="close"
            onClick={() => setOpenModal(false)}
            size="large"
          >
            <MdClose />
          </IconButton>
          <ImageSlider
            slides={folderPictures}
            setSlides={setFolderPictures}
            index={index}
          />
        </>
      </ModalStyled>
    </>
  );
}
